<template>
  <div id="start-test">
    <!-- <pre>{{ fData }}</pre> -->
    <v-card class="mx-auto">
      <v-list-item>
        <v-list-item-avatar color="grey"></v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="headline">{{ fData.tequs_name }}</v-list-item-title>
          <v-list-item-subtitle v-if="fData.show_author">by {{ fData.info.author.author_name }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <!-- <pre>{{ fData }}</pre> -->
      <!-- TODO: main image fix -->
      <!-- <v-img
        v-if="fData.main_image_url"
        :src="fData.main_image_url"
        :height="fData.main_image_height"
      ></v-img>-->

      <v-card-text>
        <div v-html="fData.tequs_info"></div>
      </v-card-text>

      <v-card-actions>
        <v-list-item class="grow">
          <v-list-item-avatar color="grey darken-3">
            <v-img
              class="elevation-6"
              src="https://avataaars.io/?avatarStyle=Transparent&topType=ShortHairShortCurly&accessoriesType=Prescription02&hairColor=Black&facialHairType=Blank&clotheType=Hoodie&clotheColor=White&eyeType=Default&eyebrowType=DefaultNatural&mouthType=Default&skinColor=Light"
            ></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title v-if="fData.tqs_assignee_name">{{ fData.tqs_assignee_name }}</v-list-item-title>
            <v-list-item-title v-else>Anonymous</v-list-item-title>
          </v-list-item-content>

          <v-row align="center" justify="end">
            <div v-if="fData.duration">
              <v-icon class="mr-1">mdi-clock</v-icon>
              <span class="subheading mr-2">{{ fData.duration }} min.</span>
            </div>
            <TestConfirm></TestConfirm>
          </v-row>
        </v-list-item>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import TestConfirm from '../components/TestConfirm.vue';

export default {
  data() {
    return {
      dialog: false,
    };
  },
  components: {
    TestConfirm,
  },
  computed: {
    fData() {
      return this.$store.state.initialTestData.tequsDocument.info;
    },
  },
};
</script>

<style lang="scss" scoped></style>
